import { Middleware } from 'redux';
import createTheReduxPromiseListener from 'redux-promise-listener';
import { UniFocusActionWithPayload } from './UniFocusAction';

export type SetPayload<T, U=T> = (action: UniFocusActionWithPayload<T>, payload: T) => UniFocusActionWithPayload<U>;

export type GetPayload<T, U=T> = (action: UniFocusActionWithPayload<T>) => U;

export interface PromiseListenerAsyncFunctionConfig<T,U=T,V=any,W=any,E=any> {
   start: string;
   resolve: string;
   reject: string;
   setPayload?: SetPayload<T,U>;
   getPayload?: GetPayload<V,W>;
   getError?: GetPayload<E>;
}

export interface PromiseListenerAsyncFunction {
   asyncFunction: (...args: Array<any>) => Promise<any>;
   unsubscribe: () => void;
}

export type PromiseListener = {
   middleware: Middleware,
   createAsyncFunction: <T,U=T>(config: PromiseListenerAsyncFunctionConfig<T,U>) => PromiseListenerAsyncFunction
};

export const createReduxPromiseListener = (): PromiseListener => {
   return createTheReduxPromiseListener();
};
